




import { ELevel } from '@/services/Menus'
import { IJob } from '@/store/modules/views/job/states'
import { ISchedule } from '@/store/modules/views/schedule/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import _ from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ScheduleDetail extends VueExtendedBaseComponent {
  @Prop({ default: () => ({}) }) public job!: IJob
  @Prop() public schedule!: ISchedule
  @Prop({ default: false}) public isCaregiver!: boolean

  get description() {
    const date = this.doConvertDate(this.schedule || this.job)
    return {
      title: 'รายละเอียด',
      icon: 'briefcase',
      data: _.filter([
        { text: 'เริ่ม', value: date.start },
        { text: 'สิ้นสุด', value: date.end },
        { text: 'ประเภทบริการ', value: this.job.type },
        // { text: 'ประเภทช่วงเวลาการทำงาน', value: this.job.period },
        { text: this.isCaregiver ? 'รายได้ทั้งหมด' : 'ค่าใช้จ่ายทั้งหมด', value: `${this.numeral((this.schedule || this.job).totalPrice)} บาท` },
      ], (item) => !_.includes([' ', '', undefined], item.value) &&
        item.value !== '0 บาท'
        && !_.includes(item.value, 'undefined'),
      ),
    }
  }

  get mainPrice() {
  return this.job
    ? {
        title: 'ค่าใช้จ่ายหลัก',
        icon: 'wallet',
        data: _.filter([
          { text: 'ค่าทำสัญญา', value: `${this.numeral(this.job.contractPrice)} บาท` },
          { text: 'ค่าประกันล่วงหน้า', value: `${this.numeral(this.job.insurancePrice)} บาท` },
          { text: 'ค่าจัดส่งนักบริบาล', value: `${this.numeral(this.job.caregiverPrice)} บาท` },
          { text: 'ค่าอาหาร', value: `${this.numeral(this.job.foodPrice)} บาท` },
        ], (item) => !_.includes([' ', '', undefined], item.value) && item.value !== '0 บาท' && !_.includes(item.value, 'undefined')),
      }
      : {}
  }

  get priceDetail() {
    let priceDetail = []
    const detail = this.schedule || this.job
    if (detail.priceDetail) {
      _.forEach(detail.priceDetail, (item, index) => {
        priceDetail = _.concat(priceDetail, this.doTransformPriceDetail(item, index + 1))
      })
    }
    return { title: `${this.isCaregiver ? 'รายได้' : 'ค่าใช้จ่าย'}เพิ่มเติม`, icon: 'sack-percent', data: priceDetail }
  }

  get scheduleDetail() {
    const data = []
    if (!(_.isEmpty(this.description) || _.isEmpty(this.description.data))) { data.push(this.description) }
    if (!(this.schedule || this.isCaregiver)) {
      if (!(_.isEmpty(this.mainPrice) || _.isEmpty(this.mainPrice.data))) { data.push(this.mainPrice) }
    }
    if (!(_.isEmpty(this.priceDetail) || _.isEmpty(this.priceDetail.data))) {
      data.push(this.priceDetail)
    }
    return data
  }

  private doConvertDate(date: {startDate: string, endDate: string, startTime?: string, endTime?: string}) {
    return {
      start: `${date.startDate ? this.localeDate(date.startDate) : ''} ${date.startTime ? `${date.startTime}น.` : ''}`,
      end: `${date.endDate ? this.localeDate(date.endDate) : ''} ${date.endTime ? `${date.endTime}น.` : ''}`,
    }
  }

  private doTransformPriceDetail(item, index) {
    const data = []
    if (item.text) { data.push({ text: `${index}. ${item.text}`}) }
    if (item.price && item.unit && _.toInteger(item.price) !== 0) {
      data.push({ text: `${this.isCaregiver ? 'รายได้' : 'ค่าใช้จ่าย'} (${item.unit})`, value: `${this.numeral(item.price)} บาท` })
    }
    if (this.level.mode !== ELevel.USER) {
      if (item.caregiver) { data.push({ text: 'ส่วนของนักบริบาล', value: `${item.caregiver} %` }) }
      if (item.center) { data.push({ text: 'ส่วนของศูนย์บริการ', value: `${item.center} %` }) }
    }
    return data
  }
}
